<template>
<span>
    <span v-if="!disabled" class="odr-tooltip">
        <slot name="trigger">

        </slot>
        <div class="odr-tooltip__content">
            <div class="odr-tooltip__body">
                <slot name="content">

                </slot>
            </div>
        </div>
    </span>
    <span v-if="disabled">
        <slot name="trigger">

        </slot>
    </span>
</span>
</template>
<script>
import '../styles/tooltip.scss'

export default {
    props: {
        disabled: {
            type: Boolean,
            _descr: 'Disabled to open tooltip',
        },
    },
}
</script>
